{
  "DATE_PICKER": {
    "PREVIOUS_PERIOD": "Previous period",
    "NEXT_PERIOD": "Next period",
    "WEEK_NUMBER": "Week #{weekNumber}",
    "APPLY_BUTTON": "להגיש מועמדות",
    "CLEAR_BUTTON": "נקה",
    "DATE_RANGE_INPUT": {
      "START": "תאריך התחלה",
      "END": "תאריך סיום"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "טווח תאריכים",
      "LAST_7_DAYS": "7 הימים האחרונים",
      "LAST_30_DAYS": "30 הימים האחרונים",
      "LAST_3_MONTHS": "3 החודשים האחרונים",
      "LAST_6_MONTHS": "6 החודשים האחרונים",
      "LAST_YEAR": "שנה שעברה",
      "THIS_WEEK": "This week",
      "MONTH_TO_DATE": "החודש",
      "CUSTOM_RANGE": "טווח תאריכים מותאם אישית"
    }
  }
}
